import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';

import ALink from '~/components/features/custom-link';
import { useAuth, useProgram } from '~/hooks';
import { trackViewAccountBalance, trackViewMyRequests } from '~/sdk';

// Menú de Perfil (cuenta del usuario). Floating menu click-to-open, robusto en
// touch (cierra al click-fuera y al navegar). Arriba un RESUMEN con nombre +
// puntos: en el bar esos datos se ocultan al achicar la pantalla (d-lg-show),
// así que el resumen del menú es donde el usuario siempre los ve.
function ProfileMenu() {
  const { participant, availablePoints, loadingPoints, logOut } = useAuth();
  const { program } = useProgram();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Cerrar al navegar.
  useEffect(() => {
    setOpen(false);
  }, [router.asPath]);

  // Cerrar al hacer click fuera.
  useEffect(() => {
    if (!open) return;
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [open]);

  const displayName = participant?.firstName || participant?.fullName || 'Mi perfil';

  return (
    <div ref={ref} className={`dropdown profile-dropdown ${open ? 'show' : ''}`}>
      <a
        href="#"
        className="profile-toggle"
        onClick={(e) => {
          e.preventDefault();
          setOpen((v) => !v);
        }}
      >
        <i className="d-icon-user"></i>
        <span className="profile-text">
          <span className="profile-name">{participant?.firstName || displayName}</span>
          {participant?.lastName && (
            <span className="profile-lastname">{participant.lastName}</span>
          )}
        </span>
        <i className="d-icon-angle-down profile-caret"></i>
      </a>

      <ul className="dropdown-box">
        {/* Resumen del usuario: nombre + puntos (siempre visible en el menú). */}
        <li className="profile-summary">
          <span className="profile-summary-name">{participant?.fullName || displayName}</span>
          <span className="profile-summary-points">
            {loadingPoints ? 'Cargando...' : `${availablePoints} ${program?.coinName ?? ''}`}
          </span>
        </li>

        <li>
          <ALink href="/pages/account">Mi Cuenta</ALink>
        </li>
        <li>
          <ALink href="/pages/account/?tab=requests" onClick={() => trackViewMyRequests()}>
            Mis Solicitudes
          </ALink>
        </li>
        {program?.id !== 7 && (
          <li>
            <ALink
              href="/pages/account/?tab=account-statement"
              onClick={() => trackViewAccountBalance()}
            >
              Estado de cuenta
            </ALink>
          </li>
        )}
        <li>
          <ALink href="#" onClick={() => logOut()}>
            Salir
          </ALink>
        </li>
      </ul>
    </div>
  );
}

export default ProfileMenu;
